import { request, post } from "../request";

export const updateUser = (params) =>
  request(`/v1/user`, "put", { json: params });
export const setPassword = (params) =>
  request(`/v1/user/setPassword`, "put", { json: params });
export const updatePasswordByPwd = (params) =>
  request(`/v1/user/updatePasswordByPwd`, "put", { json: params });

export const updatePasswordBySms = (params) =>
  request(`/v1/user/updatePasswordBySms`, "put", { json: params });
export const updateMobile = (params) =>
  request(`/v1/user/updateMobile`, "put", { json: params });
export const getAvatarSts = (params) =>
  request(`/v1/cos/getAvatarSts`, "get", { params });
export const checkAccount = (params) =>
  request(`/v1/user/checkAccount`, "get", { params });

// 获取绑定和解绑微信二维码
export const getBindWechatCode = () => {
  return post("/v1/auth/wechat/wxQrBind");
};
// 解绑或者绑定微信
export const bindWechat = (params) => {
  return post("/v1/auth/wechat/checkBindStatus", params);
};
